import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "@/components/layout/HomePageLayout";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ExternalLink } from "lucide-react";

const About = () => {
  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold mb-6">About World Class Design</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-muted-foreground mb-8">
            A platform spotlighting exceptional African design talent.
          </p>

          <Separator className="my-8" />

          <div className="space-y-6">
            <p>
              World Class Design is the go-to spot where amazing African
              designers finally get their well-deserved spotlight. We're
              throwing all that incredible talent onto one platform because,
              honestly, why wasn't this a thing already?
            </p>

            <p>
              Founded by{" "}
              <a
                href="https://www.linkedin.com/in/guidionemachava/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline inline-flex items-center"
              >
                Gudione Machava <ExternalLink size={14} className="ml-1" />
              </a>
              , we offer the most comprehensive directory of African design
              talent, creating connections that wouldn't otherwise exist while
              celebrating the unique perspectives and contributions of African
              designers.
            </p>

            <p>
              By putting African designers front and center, we're not just
              building profiles—we're building bridges. More visibility means
              more gigs, more collaborations, and more "oh damn, that's good"
              moments. We're creating the design community that Africa deserves,
              turning individual talents into a collective force that the global
              design scene simply cannot ignore.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mt-12">
            <Button asChild size="lg">
              <Link to="/auth?tab=signup">Join as a Designer</Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link to="/">Browse Designers</Link>
            </Button>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default About;
